// Note URLs are `/notes/{slug}-{id}` where the slug is derived from the page
// title and is purely decorative — the 24-char ObjectId at the end is the
// source of truth. `/notes/{id}` (no slug) is always valid too.

export function slugifyNoteTitle(title?: string | null): string {
  if (!title) return "";
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
    .replace(/-+$/g, "");
}

// Recovers the real note id (trailing ObjectId) from a route segment that may
// carry a slug prefix. Falls back to the raw value if no ObjectId is present.
export function extractNoteId(segment?: string | null): string {
  if (!segment) return "";
  const matches = segment.match(/[a-f0-9]{24}/gi);
  return matches ? matches[matches.length - 1] ?? segment : segment;
}

// Boards (collection_view) get no slug — only pages are slugged.
export function buildNoteHref(id: string, title?: string | null, blockType?: string | null): string {
  const slug = blockType === "collection_view" ? "" : slugifyNoteTitle(title);
  return slug ? `/notes/${slug}-${id}` : `/notes/${id}`;
}

// Real note id for the currently-open note, read from a pathname.
export function noteIdFromPath(pathname?: string | null): string {
  if (!pathname) return "";
  return extractNoteId(pathname.split("/").pop());
}
